import { offset } from 'meteora';
function lastInRow(array, i) {
  var offset = offset(array[i]).y;
  var elements = array.slice(i);
  var last = array[i];
  for (var i = 0; i < elements.length; i++) {
    if (offset(elements[i]).y > offset) {
      break;
    } else {
      last = elements[i];
    }
  }
  return last;
}
export default lastInRow;